/**
 * SEO 配置 - chat (English)
 */

export default {
    chat: {
        title: 'AI Chat - Multi-Model Assistant | WeryAI',
        description:
            'Chat with top AI models on WeryAI. Compare responses side-by-side across multiple windows. Generate images, videos, and music from one unified AI workspace.',
        keywords:
            'AI chat, AI assistant, multi-model chat, AI chatbot, compare AI models, side-by-side AI chat, GPT chat alternative, AI workspace, WeryAI',
        og_title: 'AI Chat - Multi-Model Assistant | WeryAI',
        og_description:
            'Chat with top AI models and compare responses side-by-side. Generate images, videos, and more from one AI workspace. Try free on WeryAI.',
        twitter_title: 'AI Chat - Multi-Model Assistant | WeryAI',
        twitter_description:
            'Chat with top AI models and compare responses side-by-side. Generate images, videos, and more from one AI workspace. Try free on WeryAI.',
    },
}
